import { render, staticRenderFns } from "./BarcodeOrderPalletTable.vue?vue&type=template&id=b0c86220&scoped=true"
import script from "./BarcodeOrderPalletTable.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderPalletTable.vue?vue&type=script&lang=ts"
import style0 from "./BarcodeOrderPalletTable.vue?vue&type=style&index=0&id=b0c86220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c86220",
  null
  
)

export default component.exports